<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Gerenciamento dos Perfis.</span>
                <br/>
                <span class="navigation">Cadastros > Perfil</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <form name="form" @submit.prevent="onSubmit">
            <div>
              <template v-if="validation.hasError('perfil.nome')">
                <InlineMessage>{{ validation.firstError('perfil.nome') }}</InlineMessage>
              </template>
              <template v-else-if="validation.hasError('perfil.paginaInicial')">
                <InlineMessage>{{ validation.firstError('perfil.paginaInicial') }}</InlineMessage>
              </template>
            </div>
            <div class="row">
              <div class="col-md-6 mb-2">
                <label for="nome">Nome:</label>
                <span class="p-fluid">
                  <InputText
                    type="text"
                    id="nome"
                    v-model="perfil.nome"
                    :class="{'p-error': validation.hasError('perfil.nome')}"
                  />
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 mb-2">
                <label for="desc">Página Inicial:</label>
                <span class="p-fluid">
                  <InputText
                    type="text"
                    id="desc"
                    v-model="perfil.paginaInicial"
                    :class="{'p-error': validation.hasError('perfil.paginaInicial')}"
                  />
                </span>
              </div>
            </div>
            <hr />
            <template>
              <Button
                label="Gravar"
                title="Gravar"
                type="submit"
                class="p-button-primary mr-2 p-button-success"
                icon="pi pi-check"
                :disabled="loading"
              >
              </Button>
              <router-link to="/perfil">
                <Button
                  label="Voltar"
                  title="Voltar"
                  type="button"
                  class="p-button-primary mr-2"
                  icon="pi pi-arrow-left"
                  :disabled="loading"
                ></Button>
              </router-link>
            </template>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LoginService from "../services/acesso/login.service";
import PerfilService from "../services/nfse/perfil.service";
import Perfil from "../models/nfse/Perfil";
import SimpleVueValidation from "simple-vue-validator";
const Validator = SimpleVueValidation.Validator;

export default {
  name: "perfilCadastro",
  data() {
    return {
      currentUser: null,
      loading: false,
      perfil: new Perfil()
    };
  },
  created() {
    this.currentUser = LoginService.currentUserValue;
    this.perfilId = this.$route.params.id;

    if (this.perfilId != null) {
      setTimeout(async () => {
        await PerfilService.get(this.perfilId).then(
        response =>{
          this.perfil = response.data;
        },
        error => {
          let errorMessage = "Houve um problema ao buscar o Perfil!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        });
      }, 250);
    }
  },
  validators: {
    "perfil.nome": function(value) {
      return Validator.value(value)
        .required("Nome Obrigatório")
        .maxLength(100, "Deve ser menor ou igual a 100");
    },
    "perfil.paginaInicial": function(value) {
      return Validator.value(value)
        .required("Página Inicial Obrigatório")
        .maxLength(100, "Deve ser menor ou igual a 100");
    }
  },
  methods: {
    onSubmit() {
      this.loading = true;
      this.$validate().then(success => {
        if (success) {
          this.salvar();
        }
      });
      this.loading = false;
    },
    salvar() {
      this.perfil.idCliente = this.currentUser.usuario.idCliente;
      PerfilService.save(this.perfil).then(
        data => {
          console.log(data);
          this.$toast.add({
            severity: "success",
            summary: "Perfil salvo com sucesso"
          });
          this.$router.push("perfil");
        },
        error => {
          let errorMessage = "Houve um problema ao salvar o Perfil!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      );
    }
  }
};
</script>

<style scoped>
</style>